<template>
   <div class="root-wrapper">
     <slot v-if="showContent"></slot>
     <v-app  v-else>
       <v-content>
         <v-container >
           <v-layout wrap justify-center align-center>
             <v-flex xs12 text-center pt-4 mt-4>
               <h1 class="title font-weight-light mt-4">Hay problemas con tu cuenta.</h1>
               <v-img :src="require('@/assets/img/account/account_issues.png')" max-width="500" class="mx-auto" />
             </v-flex>
             <v-flex xs12 text-center>
               <v-btn v-if="isOwner && $route.name !== 'panel.provider.settings'" color="secondary" small rounded class="py-1 px-3" :to="{
                name: 'panel.provider.settings',
                query: {
                  view: 'SubscriptionSettings'
                }
              }">
                 <v-icon size="14" class="mr-1">fa-credit-card</v-icon>
                 revisar cuenta
               </v-btn>
               <v-btn @click="logout" depressed outlined color="accent" class="ml-1" small rounded>
                 <v-icon size="14" class="mr-1">fa-sign-out-alt</v-icon>
                 Cerrar sesión
               </v-btn>
             </v-flex>
           </v-layout>
         </v-container>
       </v-content>
     </v-app>
   </div>

</template>

<script>
import {mapGetters, mapState, mapMutations} from 'vuex'
import {ApiUtils} from '@/utils/ApiUtils';

export default {
  name: "SubscriptionVerifier",
  computed:{
    ...mapGetters([
      'currentSubscription',
      'subscribedPlan',
      'subscriptionWasCancelled',
      'accountSuspended',
      'paymentFailed',
      'planPurchaseNeeded'
    ]),
    ...mapState(['currentProvider']),
    showContent(){
      const vm = this
      if(vm.currentUser && vm.currentUser.super) return true;

      return !vm.showSubscriptionVerifier ||
              (vm.showSubscriptionVerifier && !vm.shouldBlock)
    },
    showSubscriptionVerifier() {
      const vm = this
      if (!vm.$route.meta || !vm.$route.meta.subscription) return true
      return Boolean(vm.$route.meta.subscription.verify)
    },
    subscriptionHasIssues(){
      const vm = this
      return vm.paymentFailed || vm.subscriptionWasCancelled || vm.accountSuspended || vm.planPurchaseNeeded
    },
    message(){
      const vm = this

      if(!vm.subscriptionHasIssues){
        return ''
      }

      if(vm.planPurchaseNeeded){
        return 'El periodo de prueba ha expirado.'
      }

      if(vm.paymentFailed){
        return 'El pago ha fallado.'
      }

      if(vm.accountSuspended){
        return 'Esta cuenta fue suspendida'
      }

      if(vm.subscriptionWasCancelled){
        return 'Esta subscripción fue cancelada.'
      }

    },
    additionalMessage(){
      const vm = this
      if(!vm.isOwner && vm.subscriptionHasIssues){
        return 'El dueño de la cuenta debe revisar la subscripción.'
      }

      return ''

    },
    shouldBlock(){

      const vm = this

      const blockCondition = vm.subscriptionWasCancelled || vm.accountSuspended || vm.planPurchaseNeeded;

      if(!vm.$route.meta || !vm.$route.meta.subscription){
        return blockCondition
      }

      return Boolean(vm.$route.meta.subscription.block) && blockCondition
    }
  },
  methods:{
    ...mapMutations(['blurWrapper']),
    logout(){
      ApiUtils.logout()
    }
  },
  watch:{
    shouldBlock(){}
  }
}
</script>

<style scoped>
  .blocker-wrapper{
    position: fixed;
    top:-5px;
    height: 70px;
    width: 100%;
    z-index: 10;
  }

  .blocker-wrapper.mobile{
    height: 60px;
  }

  .message{
    font-family: Roboto, sans-serif;
    size: 12px;
    color: #fff;
  }

  .overlay{
    position: fixed;
    top: 69px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.5);
  }


</style>
